exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hideUpload > div {\n  display: none;\n}\n.input-class {\n  width: 200px;\n  margin-right: 15px;\n}\n.text-class {\n  margin-right: 10px;\n}\n", ""]);

// exports
